import { render } from "./LayoutVariantTwo.vue?vue&type=template&id=05554286&scoped=true"
import script from "./LayoutVariantTwo.vue?vue&type=script&lang=js"
export * from "./LayoutVariantTwo.vue?vue&type=script&lang=js"

import "./LayoutVariantTwo.vue?vue&type=style&index=0&id=05554286&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05554286"]])

export default __exports__